import Client from '../axiosClient'
const resource = '/price';
const resourceInit = '/prices_initialize';

// TODO remove l1Axios and l2Axios once all the APIs is configured with courier, i.e, L2 instance
export default {
  init() {
    return Client.get(`${resourceInit}`);
  },
  get() {
    return Client.get(`${resource}?filters={"type":"formatted"}`);
  },

  getById(id) {
    return Client.get(`${resource}?filters={"type":"formatted","packageId":"${id}"}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },

  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/travel/priceRepository.js